import React, { useEffect, useState, useRef } from 'react'
import propTypes from 'prop-types'
import { Grid, Box, ButtonBase } from '@material-ui/core';
import styled, { keyframes } from 'styled-components';
import { gql } from 'apollo-boost';
import { get } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import Text from '../../components/typography';
import { theme } from '../../themes/default-theme';
import ResponsiveImage from '../../components/ui/RespImg';
import { Cta } from '../../components/ui';
import IconLink from '../../components/ui/IconLink';
import BackIcon from '../../assets/icons/back-icon.svg';
import floorplanAdult from '../../assets/icons/floorplanAdult.svg';
import floorplanChild from '../../assets/icons/floorplanChild.svg';
import { ReactSVG } from 'react-svg';
import plusSvg from '../../assets/icons/plus-white.svg';
import NavArrowRight from '../../assets/icons/new_nav_arrow_right.svg';
import Modal from '../../components/ui/Modal';
import SpecsTable from '../../components/content/SpecsTable';
import jaycoClient from '../../../src/graphql/jaycoClient';
import getModelDataQuery from '../../../src/graphql/queries/models-floor-plan/model-data';
import RadioCheck from '../../assets/icons/radio-button.svg';
import RadioCheckMobile from '../../assets/icons/radio-button-mobile.svg';
import { useMediaQuery } from '@material-ui/core';
import { modelStepsData } from '../../components/methods/modelStepsData';
import ModelStepsCounter from '../../components/ui/ModelStepsCounter';
import { setSavedData, getSavedData } from '../../components/methods/setLocalStorage';
import Link from 'next/link';
import ModelPrice from '../../components/content/ModelPrice';
import { buildPriceData } from '../../components/methods/buildPriceDataName';
import { BuildPriceRouteName } from '../../components/methods/buildPriceRouteName';
import { useInView } from 'react-intersection-observer';
import ModelFooter from '../../components/content/ModelFooter';
import LoaderIcon from '../../assets/icons/loader.png';
import getPriceKey from '../../util/getPriceKey';
import { useRouter } from 'next/router';
import ReactHtmlParser from 'react-html-parser';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Container = styled.div`
    max-width: 1400px;
    margin: auto;
    ${props => props.errorPage && `
        > a, > button {
            display: flex;
            margin: 40px auto;
            width: 100%;
            max-width: 445px;
            border-top: none;
            text-decoration: none;
        }
    `}
    ${theme.breakpoints.down('1500')} {
        & {
            > div {
                > div {
                    > div {
                        > a {
                            margin-left: 63px;
                        }
                    }
                }
            }
        }
    }
    ${theme.breakpoints.up('md')} {
        padding-bottom: 137px;
        & {
            > div {
                > div {
                    > div {
                            &:first-child {
                                margin-top: 30px;
                                position: relative;
                                z-index: 5;
                            }
                            > a {
                                font-size: 14px;
                                font-style: normal;
                                font-weight: 700;
                                line-height: 21px;
                                text-transform: uppercase;
                                text-decoration: none;
                                display: flex;
                                align-items: center;
                                &:before {
                                    content: url(${NavArrowRight});
                                    margin-right: 10px;
                                    transform: scale(-1);
                                    filter: brightness(0) saturate(100%) invert(26%) sepia(36%) saturate(4535%) hue-rotate(194deg) brightness(103%) contrast(99%);
                                }
                                ~ div {
                                    margin-right: 60px;
                                    margin-left: 63px;
                                    max-width: 750px;
                                }
                               
                            }
                    }
                }
            }
        }
    }
    h2 {
        max-width: 815px;
        margin-left: auto;
        margin-right: auto;
    }
    h1 {
        margin-bottom: 20px;
        color: #010101;
        ${theme.breakpoints.up('md')} {
            font-size: 34px;
            padding-top: 37px;
        }   
        ${theme.breakpoints.down('sm')} {
            font-size: 18px;
            padding-top: 25px;
        } 
    }
`
const SectionsContainer = styled.div`
    ${theme.breakpoints.up('md')} {
        display: flex;
        gap: 60px;
    }
`
const FirstSection = styled.div`
    width: 100%;
`

const SecondSection = styled.div`
    width: 100%;
    overflow: hidden;
    label {
        padding: 0 12px;
        background: ${theme.palette.white};
    }
    ${theme.breakpoints.up('md')} {
        max-width: 445px;
        max-width: 400px;
        min-width: 400px;
        padding-left: 60px;
        border-left: 1px solid #D9D9D9;
    }
    ${theme.breakpoints.up('992')} {
        max-width: 445px;
    }
`

const FloorplanHead = styled.div`
    margin: 20px 0;
    color: ${theme.palette.charcoal};
    ${theme.breakpoints.up('md')} {
        h4 {
            font-size: 22px;
            line-height: 22px;
        }
    }
    ${theme.breakpoints.up('lg')} {
        margin: 40px 0 20px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-bottom: 20px;
        h4 {
            font-size: 16px;
            line-height: 22px;
        }
    }
`

const Hr = styled.hr`

    border-top: 1px solid ${theme.palette.middleGrey};
    border-bottom: 0;
    border-left: 0;
    border-right: 0;

    ${props => props.medium && `
        ${theme.breakpoints.down('sm')} {
            display: none;
        }
    `}

`

const TabsContainerConfig = styled.div`
    ${theme.breakpoints.down('sm')} {
        width: 100%;
        margin-bottom: 80px;
    }

`


const FloorplanContainer = styled.div`
    margin: auto;
    

    ${theme.breakpoints.up("md")} {

    }

    h4 {
        letter-spacing: 0;
    }
`

const FloorplanImg = styled.div`
    ${props => props.loading ? `
        display: none;
    `:`
        display: block;
    `}
    ${theme.breakpoints.up("md")} {
         margin-top: 70px;
    }
`
const Loader = styled.div`
    text-align: center;
    align-items: center;
    justify-content: center;
    > img {
        animation: ${rotate} 2s linear infinite;
    }
    ${theme.breakpoints.up('md')} {
        min-height: 150px;
    }
    ${theme.breakpoints.up('lg')} {
        min-height: 300px;
    }
    ${theme.breakpoints.down('sm')} {
        min-height: 130px;
    }
    ${props => props.loading ? `
        display: flex;
    `:`
        display: none;
    `}

`

const FloorplanContent = styled.div`
    position: relative;
    h4 {
        margin-bottom: 20px;
    }

    sup {
        font-size: 16px;
        margin-left: 5px;
        font-weight: 500;
    }

    hr {
        margin: 23px 0;
    }
    width: 100%;
    height: 100%;
    ${theme.breakpoints.up("md")} {
        max-width: 445px;
        float: right;
    }
    ${theme.breakpoints.down("sm")} {
        padding-bottom: 60px;
    }

`
const ButtonContainer = styled.div`
    ${theme.breakpoints.down('sm')} {
        padding-top: 8px;
        border-top: 1px solid ${theme.palette.middleGrey};
        width: 100%;
        left: 0;
        padding: 11px 20px;
        z-index: 115;
        background: #F3F4F7;
        max-width: 100%;
        position: absolute
    }
    ${props => props.fixed == 1 && `
        ${theme.breakpoints.down('sm')} {
            position: fixed;
            bottom: 70px;
        }
    `}
    ${props => props.disablePrice == 1 && props.fixed == 1 && `
        ${theme.breakpoints.down('sm')} {
            bottom: 0;
        }
    `}
`
const ButtonContainerError = styled.div`
        margin: 40px auto;
        max-width: 445px;
        border-top: none;
`


const Floorplans = styled.div`

`

const FloorplanConfiguration = styled(ButtonBase)`
    background-color: ${theme.palette.white};
    width: 100%;
    display: block;
    justify-content: start;
    border-radius: 6px; 
    margin-right: 8px;
    text-align: left;
    border-radius: 8px;
    border: 1px solid #DCDCDC; 
    margin-bottom: 12px;
    position: relative;
    &:before {
        content: "";
        font-size: 1rem;
        display: inline-block;
        background: inherit;
        border: 1px solid #979797;
        border-radius: 59px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    ${props => props.active == 1 && `
        border: 2px solid ${theme.palette.vividBlue};
        &:before {
            background: #0170D4;
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            ${theme.breakpoints.up('md')} {
                content: url(${RadioCheck});
            }
            ${theme.breakpoints.down('sm')} {
                content: url(${RadioCheckMobile});
            }
        }
    `}
    ${theme.breakpoints.up("md")} {
        padding: 13px;
        > * {
            margin-left: 41px;
        }
        &:before {
            width: 25px;
            height: 25px;
        }
    }
    ${theme.breakpoints.down("sm")} {
        > * {
            margin-left: 35px;
        }
        min-width: auto;
        padding: 10px;
        &:before {
            width: 19px;
            height: 19px;
        }
    }
    
`

const FloorplanConfigurationIcons = styled.div`
    ${theme.breakpoints.down("sm")} {
        white-space: nowrap;
    }
`
const ActiveConfigurationContainer = styled.div`
    margin-top: 5px;
    border-radius: 8px;
    border: 1px solid #DCDCDC;
    padding: 10px;
    max-width: 750px;
`

const FloorplanConfigurationText = styled.div`
    line-height: 14px;
    strong {
        font-size: 14px;
    }
    p {
        margin: 0;
        font-size: 12px;
        line-height: 14px;
    }
`
const FloorplanConfigurationAdditionalPrice = styled.div`
    position: absolute;
    right: 10px;
    top: 50px;
    transform: translateY(-50%);
`

const Adults = styled.div`
    display: inline-block;
    // margin-right: 5px;
`

const Adult = styled.div`
    display: inline-block;
    margin-right: 5px;
    svg {
        path {
            fill: ${theme.palette.vividBlue};
        }
    }
`

const Children = styled.div`
    display: inline-block;
`

const Child = styled.div`
    display: inline-block;
    margin-right: 2px;

    ${props => props.opacity == 1 && `
        opacity: 0.5; 
    `}
`

const Plus = styled.span`
    display: inline-block;
    vertical-align: middle;
    color: ${theme.palette.charcoal};
    position: relative;
    top: -5px;
    svg {
        path {
            fill: ${theme.palette.vividBlue};
        }
    }
`

const FloorplansText = styled(Text)`
    margin: 20px 0;
    color: ${theme.palette.charcoal};
    ${theme.breakpoints.up('md')} {
        h4 {
            font-size: 22px;
            line-height: 22px;
        }
    }
    ${theme.breakpoints.up('lg')} {
        margin: 40px 0 20px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-bottom: 20px;
        h4 {
            font-size: 16px;
            line-height: 22px;
        }
    }
`

const Back = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 12px;
    line-height: 21px;
    > div {
        line-height: 0;
    }
    a {
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        color: ${theme.palette.charcoal};
        text-decoration: none;
    }
`

const Specifications = styled.div`
    padding-bottom: 9px;
    > div {
        font-size: 15px;
    }
`

const SpecsFeatures = styled.div`
    display: flex;
    flex-wrap: wrap;
    // margin-bottom: 20px;
    border-top: 1px solid ${theme.palette.middleGrey};

    ${theme.breakpoints.up("md")} {
        font-size: 16px;
    }
`

const SpecsFeaturesItem = styled.div`
    display: flex;
    color: inherit;
    ${props => (props.index) && (props.index % 2 == 0) ? `
        &:not(:nth-child(${props.index})):not(:nth-child(${props.index - 1})) {
            border-bottom: 1px solid ${theme.palette.middleGrey};
        }
        `: `
        &:not(:nth-child(${props.index})) {
            border-bottom: 1px solid ${theme.palette.middleGrey};
        }
    `}
    padding: 10px 0;
    width: 100%;
    font-size: 14px;
    ${theme.breakpoints.up("md")} {
        min-width: 50%;
        max-width: 50%;
        padding: 5px 0;
        font-size: 16px;
    }
`

const SpecsFeaturesTitle = styled.div`
    min-width: 50%;
    max-width: 50%;
    padding-right: 20px;
    color: #2E3238;
`

const SpecsFeaturesValue = styled.div`
    width: 100%;
    padding-right: 20px;
    color: #2E3238;
`

const Specs = styled.div`
    margin: 20px 0 0;
    max-width: 750px;
    h6 {
        margin-bottom: 20px;
    }   
    > div {
        > div {
            > div {
                padding: 0;
                > div {
                    &:first-child {
                        font-size: 15px;
                        letter-spacing: 1px;
                        padding-bottom: 9px;
                    }
                }
            }
        }
    }
    ${theme.breakpoints.up("md")} {
        margin: 50px 0;
    }
`
const CounterSection = styled.div`
    ${theme.breakpoints.down('md')} {
        margin-bottom: 60px;
    }
`
const ModelPriceContainer = styled.div`
    position: fixed;
    width: 100%;
    right: 0;
    z-index: 3;
    ${theme.breakpoints.up('lg')} {
        > div {
            width: 100%;
        }
    }
    ${theme.breakpoints.up('md')} {
        bottom: -4px;
        > div {
            float: right;
        }
    }
    ${theme.breakpoints.down('sm')} {
        bottom: -4px;
        > div {
            width: 100%;
            margin-top: 15px;
        }
    }
    ${props => props.fixed == 1 ? `
        position: fixed;
        ${theme.breakpoints.down('sm')} {
            bottom: 0;
        }
    `:`
        position: absolute;
        ${theme.breakpoints.down('sm')} {
            bottom: -4px;
        }
    `}
    ${theme.breakpoints.up('md')} {
        > div {
            float: right;
        }
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${400 + props.containerWidth}px;
                max-width: ${400 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${400 + 0}px;
                max-width: ${400 + 0}px;
            }
        `}
    }
    ${theme.breakpoints.up('992')} {
        ${props => props.containerWidth > 0 ? `
            > div {
                min-width: ${445 + props.containerWidth}px;
                max-width: ${445 + props.containerWidth}px;
            }
        `:`
            > div {
                min-width: ${445 + 0}px;
                max-width: ${445 + 0}px;
            }
        `}
    }
    ${theme.breakpoints.down('sm')} {
        > div {
            width: 100%;
            margin-top: 15px;
        }
    }
`

const InviewContainer = styled.div`
    height: 50px;
    width: 50px;
    position: absolute;
    bottom: 0;
`
const ModelFooterContainer = styled.div`
    ${theme.breakpoints.down('1500')} {
        margin-left: 63px;
        width: calc(100% - 458px);
        padding-right: 20px;
        position: relative;
        z-index: 4;
    }
    ${theme.breakpoints.up('md')} {
        margin-bottom: 35px;
    }
    ${theme.breakpoints.down('sm')} {
        margin-left: 0;
        margin-bottom: 20px;
        width: 100%;
        max-width: 100%;
        position: relative;
        top: -71px;
    }
`
const DisclaimerText = styled.div`
    > div {
        font-size: 10px!important;
        line-height: 16px;
        color: #2E3238;
        letter-spacing: normal!important;
        margin-top: 10px;
        margin-bottom: 4px;
    }
`

const useStyles = makeStyles(theme => ({
    modalInner: {
        maxWidth: 1220,
        margin: '0 auto',
        display: 'inline-block',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            maxWidth: 1320,
            paddingLeft: 50,
            paddingRight: 50
        }
    },
}))

const ModelFloorplanConfiguration = (props) => {

    const {
        models,
        seriesName,
        seriesUrl,
        seriesParams,
        modelName,
        modelUrl,
        modelParams,
        floorplans,
        uri,
        cta,
        financeLink,
        brochureLink,
        specsFeatures,
        colourTheme,
        background,
        rangeId,
        seriesId,
        modelPrice,
        currentWidth,
        dealers,
        countryProps
    } = props;

    let res = JSON.parse(getSavedData(buildPriceData)) || {};
    if( res && res.seriesName && seriesName && res.seriesName == seriesName) {
        res = res;
        if(res?.selectedModel) {
            res.selectedModel = res.selectedModel
        } else {
            res.selectedModel = models[0];
        }
    } else {
        res = {};
        if(res?.selectedModel) {
            res.selectedModel = res.selectedModel
        } else {
            res.selectedModel = models[0];
        }
        res.seriesName = seriesName && seriesName;
    }

    // const [activeModel, setActiveModel] = useState(res.selectedModelFloorplan?.activeModelIndex ? models[res.selectedModelFloorplan.activeModelIndex] : models[0]);
    // const [activeModelIndex, setActiveModelIndex] = useState(0);
    const [price, updatePrice] = useState(null);
    // const [financePerWeek, setFinancePerWeek] = useState(0)
    const [floorplan, setFloorplan] = useState(get(models[0], 'floorplans[0].floorplan', models[0].floorplans[0].floorplan));
    const [activeConfiguration, setActiveConfiguration] = useState(null);
    const [errorSavedData, setErrorSavedData] = useState(null);

    const [modal, openModal] = useState(false);
    const [currentPrice, setCurrentPrice] = useState(0);
    const [additionalPrice, setAdditionalPrice] = useState(
        res && res.additionalPrice ?
            parseFloat(res.additionalPrice)
            : res && res.selectedModelFloorplan && res.selectedModelFloorplan.activeConfiguration && res.selectedModelFloorplan.activeConfiguration.additionalPrice ?
                parseFloat(res.selectedModelFloorplan.activeConfiguration.additionalPrice)
                : activeConfiguration ?
                    parseFloat(activeConfiguration.additionalPrice)
                    : 0
    );
    const [fixed, setFixed] = useState(true);
    const [loading, setLoading] = useState(true);
    const [getLocation, setGetLocation] = useState(null);
    const [openPostcodePopup, setOpenPostcodePopup] = useState(false);
    const router= useRouter();
    const disabledSteps = [''];
    // Media Breakpoint Start
    const media = useMediaQuery(theme.breakpoints.up('0'));
    const desktopView = useMediaQuery(theme.breakpoints.up('md'));
    const mobileView = useMediaQuery(theme.breakpoints.down('sm'));
    // Media Breakpoint End

    const handleLaunchModal = (e) => {
        if (e) {
            e.preventDefault();
        }
        console.log('launch modal', e);
        openModal(true);
    }

    // console.log('Floorplan props:', { props });

    const mainFontColour = colourTheme === 'light' ? 'charcoal' : 'white'

    const openPostcode = (e) => {
        e.preventDefault();
        setOpenPostcodePopup(!openPostcodePopup);
    }

    const getCurrentSetLocation = (currentLocation) => {
        setGetLocation(currentLocation)
    }

    const handleSaveData = () => {

        if (activeConfiguration && res && res.seriesName && seriesName && res.seriesName != seriesName) {
            res = {};
            res.seriesName = seriesName;
            res.currentPrice = currentPrice;
            res.additionalPrice = additionalPrice;
            if(res?.selectedModelFloorplan?.activeConfiguration) {
                res.selectedModelFloorplan.activeConfiguration = activeConfiguration;
            }
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        } else if (activeConfiguration && seriesName) {
            res.seriesName = seriesName;
            res.currentPrice = currentPrice;
            res.additionalPrice = additionalPrice;
            if(res?.selectedModelFloorplan?.activeConfiguration) {
                res.selectedModelFloorplan.activeConfiguration = activeConfiguration;
            }
            setSavedData(
                buildPriceData,
                JSON.stringify(
                    res
                ),
                86400 // 1 day
            );
        } else {
            setErrorSavedData('There is option missing')
        }
        setSavedData(
            BuildPriceRouteName,
            router?.pathname && router.pathname,
            7200 // 2 hours
        );
    }

    const onLoad = () => {
        setLoading(false);
    };

    useEffect(() => {

        const getData = async () => {
            //   setLoading(true);

            const GET_MODEL_DATA = gql`
            ${getModelDataQuery}
          `

            const result = (floorplan && floorplan.floorplanId) ? await jaycoClient.query({
                query: GET_MODEL_DATA,
                variables: {
                    id: floorplan.floorplanId
                }
            }) : {};

            // Populate these items to specs

            const key = getLocation?.data?.contact ? getPriceKey(getLocation.data.contact) : getPriceKey();
            if (key) {
                const priceVal = result.data && result.data.getModel ? result.data.getModel[key] : 0; // get(result, `data.getModel[${pricingKey}]`, null);
                priceVal && priceVal > 0 && updatePrice(priceVal);
            }
        }

        getData();

    }, [floorplan, getLocation && getLocation]);

    const classes = useStyles();

    // useEffect(() => {
    //     if (props.rates) {
    //         const repayment = calculateRepayment({
    //             rates: props.rates,
    //             paymentFrequency: 52,
    //             price: (price + (activeConfiguration.additionalPrice ? parseInt(activeConfiguration.additionalPrice) : 0))
    //         });

    //         setFinancePerWeek(repayment);
    //     }

    // }, [price, activeConfiguration]);

    const ref = useRef(null);


    useEffect(() => {
        setCurrentPrice(
            res && res.currentPrice ?
            res.currentPrice
            : res && res.selectedModelFloorplan && res.selectedModelFloorplan.activeFloorPlanModel && res.selectedModelFloorplan.activeFloorPlanModel.floorplan && res.selectedModelFloorplan.activeFloorPlanModel.floorplan.price ?
                res.selectedModelFloorplan.activeFloorPlanModel.floorplan.price
                : price ?
                    price
                    : 0
        )
    }, [res, price])

    const { ref: inViewRef, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
      });

    useEffect(() => {
        const handleScroll = (e) => {
             if ((!inView)) {
                setTimeout(() => {

                setFixed(true)
                }, 300)
            } else {
                setTimeout(() => {
                 setFixed(false)
                }, 300)
            }
        }
        handleScroll();
        window.addEventListener("resize", handleScroll);
        return () => {
             window.removeEventListener("resize", handleScroll);
        }

    }, [inView && inView, media]);

    useEffect(() => {
        setActiveConfiguration(
            (models && models.length > 0 && models[0].floorplans && models[0].floorplans.length > 0) &&
            (   res && res.selectedModelFloorplan && res.selectedModelFloorplan.activeFloorplanIndex && res.selectedModelFloorplan.activeConfiguration && models[0].floorplans[0].floorplan && models[0].floorplans[0].floorplan.configurations && models[0].floorplans[0].floorplan.configurations.some((item) => item.id == res.selectedModelFloorplan.activeConfiguration.id)) ?            
                    res.selectedModelFloorplan.activeConfiguration
                :
                    models[0].floorplans[0].floorplan.configurations[0]
        )
    }, [models])

    // console.log('res floorplan config', res && res);

    return (
        <>
        {res && (res.seriesName == seriesName) && (res?.selectedModelFloorplan?.activeFloorPlanModel?.uri == modelName) && res.selectedModel && Object.values(res.selectedModel).length > 0 && res.selectedModelFloorplan && Object.values(res.selectedModelFloorplan).length > 0 &&
  
        <Container background={background} colourTheme={colourTheme} ref={ref}>
            {(floorplan && floorplan.specsFeatures) &&
                <Modal
                    isOpen={modal}
                    onClose={() => openModal(false)}
                    // overlayClassname={classes.modalOverlay}
                    innerClassname={classes.modalInner}
                // closeClassname={classes.modalClose}
                >
                    <SpecsTable
                        {...floorplan.specsFeatures.modal}
                        background={colourTheme === 'dark' || background === 'black' ? 'black' : 'white'}
                        rangeId={rangeId}
                        seriesId={seriesId}
                        uri={uri}
                    />
                </Modal>
            }

            <FloorplanContainer>
                {seriesName && mobileView &&
                    <Text variant="h1" weight={800} uppercase>{seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
                }
                {mobileView &&
                    <CounterSection>
                        <ModelStepsCounter
                            modelStepsData={modelStepsData(seriesUrl && seriesUrl.link && seriesUrl.link.href, res?.selectedModelFloorplan?.activeFloorPlanModel?.uri && res.selectedModelFloorplan.activeFloorPlanModel.uri, disabledSteps, 2)}
                            handleSaveData={handleSaveData}
                        />
                    </CounterSection>
                }
                <SectionsContainer>
                    <FirstSection>
                        {desktopView &&
                            <Link href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? `${seriesUrl.link.href}/floorplan` : '#'}>
                                <a>
                                    Back
                                </a>
                            </Link>
                        }
                        {activeConfiguration &&
                            <>
                                <Loader loading={loading}>
                                    <img src={LoaderIcon} alt="loader" />
                                </Loader>
                                <FloorplanImg onLoad={onLoad}>
                                    <ResponsiveImage
                                        // loading={loading}
                                        {...activeConfiguration.image} type={'png'}
                                    />
                                </FloorplanImg>
                            </>
                        }
                        {activeConfiguration &&
                            <ActiveConfigurationContainer>
                                <FloorplanConfigurationIcons>
                                    <Adults>
                                        {Array.apply(null, { length: activeConfiguration.sleepsAdults }).map((i, index) => {
                                            return (
                                                <Adult key={index}>
                                                    <ReactSVG key={index} src={floorplanAdult} />
                                                </Adult>
                                            )
                                        })}
                                    </Adults>
                                    {(activeConfiguration.sleepsChildren > 0) &&
                                        <>
                                            <Plus>
                                                <ReactSVG src={plusSvg} />
                                            </Plus>
                                            <Children>
                                                {Array.apply(null, { length: activeConfiguration.sleepsChildren }).map((i, index) => {
                                                    return (
                                                        <Child key={index}>
                                                            <ReactSVG key={index} src={floorplanChild} />
                                                        </Child>
                                                    )
                                                })}
                                            </Children>
                                        </>
                                    }
                                    {(activeConfiguration.sleepsAdditional > 0) &&
                                        <>

                                            <Plus>
                                                <ReactSVG src={plusSvg} />
                                            </Plus>
                                            <Children>
                                                {Array.apply(null, { length: activeConfiguration.sleepsAdditional }).map((i, index) => {
                                                    return (
                                                        <Child opacity={1} key={index}>
                                                            <ReactSVG key={index} src={floorplanChild} />
                                                        </Child>
                                                    )
                                                })}
                                            </Children>
                                        </>
                                    }
                                </FloorplanConfigurationIcons>
                                <FloorplanConfigurationText>
                                    {activeConfiguration.size &&
                                        <strong>{activeConfiguration.size}</strong>
                                    }
                                    {activeConfiguration.shape &&
                                        <p>{activeConfiguration.shape}</p>
                                    }
                                </FloorplanConfigurationText>
                            </ActiveConfigurationContainer>
                        }
                        {desktopView &&
                            <Specs>
                                <Grid container direction={'row'}>
                                    <Grid>
                                        {(floorplan && floorplan.specsFeatures) &&
                                            <>
                                                <Specifications>
                                                    <Text variant="body2" uppercase weight={700} colour={mainFontColour}>Specifications</Text>
                                                </Specifications>
                                                <SpecsFeatures colour={colourTheme === 'dark' ? 'white' : 'black'}>
                                                    {floorplan.specsFeatures.specs.map((item, index) => {
                                                        return (
                                                            <SpecsFeaturesItem key={item.item ? item.item : index} index={floorplan.specsFeatures.specs.length}>
                                                                <SpecsFeaturesTitle>{item.title}</SpecsFeaturesTitle>
                                                                <SpecsFeaturesValue>{item.value}</SpecsFeaturesValue>
                                                            </SpecsFeaturesItem>
                                                        )
                                                    })}
                                                </SpecsFeatures>

                                                <DisclaimerText>
                                                    <Text variant="body2">The weights and dimensional data are not binding. Jayco reserve the right to alter specifications without notice. These are a guide only and will change depending on accessories fitted to your van. It is advised to discuss this with your Jayco representative. The load carrying capacity of Jayco RV’s vary from product to product to ensure it is fit-for-purpose.</Text>
                                                </DisclaimerText>
                                                
                                                <IconLink
                                                    onClick={handleLaunchModal}
                                                    link={{
                                                        title: 'View all SPECS & FEATURES'
                                                    }}
                                                    colour={colourTheme === 'dark' ? 'white' : 'black'}
                                                />
                                            </>
                                        }
                                    </Grid>
                                </Grid>
                            </Specs>
                        }

                        {/* <Box px={2}>
                            <FloorplansText variant="body1" colour={mainFontColour} small>
                                {`Sleeps ${activeConfiguration.sleepsAdults} adults${activeConfiguration.sleepsChildren ? ` + ${activeConfiguration.sleepsChildren} children` : ''}${activeConfiguration.sleepsAdditional ? ` + ${activeConfiguration.sleepsAdditional} additional`: ''}`}
                            </FloorplansText>
                            <Hr />
                        </Box> */}
                    </FirstSection>
                    <SecondSection>
                        {floorplan && floorplan.title &&
                            <FloorplanContent>
                                {seriesName && desktopView &&
                                    <Text variant="h1" weight={800} uppercase>{seriesName.indexOf('Jayco') > -1 ? seriesName : `Jayco ${seriesName}`}</Text>
                                }
                                {desktopView &&
                                    <CounterSection>
                                        <ModelStepsCounter
                                            modelStepsData={modelStepsData(seriesUrl && seriesUrl.link && seriesUrl.link.href, res?.selectedModelFloorplan?.activeFloorPlanModel?.uri && res.selectedModelFloorplan.activeFloorPlanModel.uri, disabledSteps, 2)}
                                            handleSaveData={handleSaveData}
                                        />
                                    </CounterSection>
                                }

                                <TabsContainerConfig>
                                    <FloorplansText variant="body1" colour={mainFontColour}>
                                        <Text variant="h4" weight={700}>Select a Floor Plan Configuration</Text>
                                    </FloorplansText>
                                    <Floorplans>
                                        <Back>
                                            <ReactSVG src={BackIcon} />
                                            <Link href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? `${seriesUrl.link.href}/floorplan` : '#'}>
                                                Back to floorplan
                                            </Link>
                                        </Back>
                                        {floorplan && floorplan.configurations && floorplan.configurations.map((item, index) => {
                                            return (
                                                <FloorplanConfiguration key={item.id} onClick={() => {
                                                    setActiveConfiguration(item)

                                                    setAdditionalPrice(
                                                        parseFloat(item.additionalPrice ? item.additionalPrice : 0) +
                                                        parseFloat((res?.selectedInteriorDecors?.activePrice ? res.selectedInteriorDecors.activePrice : 0)) +
                                                        parseFloat(res?.selectedOptions && res.selectedOptions.length > 0 ? res.selectedOptions.map((item) => item.price).reduce((a, b) => a + b, 0) : 0)
                                                    )
                                                }} active={activeConfiguration && activeConfiguration.id && item.id === activeConfiguration.id ? 1 : 0}>
                                                    <FloorplanConfigurationIcons>
                                                        <Adults>
                                                            {Array.apply(null, { length: item.sleepsAdults }).map((i, index) => {
                                                                return (
                                                                    <Adult key={item.id + index}>
                                                                        <ReactSVG key={item.id + index} src={floorplanAdult} />
                                                                    </Adult>
                                                                )
                                                            })}
                                                        </Adults>
                                                        {(item.sleepsChildren > 0) &&
                                                            <>
                                                                <Plus>
                                                                    <ReactSVG src={plusSvg} />
                                                                </Plus>
                                                                <Children>
                                                                    {Array.apply(null, { length: item.sleepsChildren }).map((i, index) => {
                                                                        return (
                                                                            <Child key={item.id + index}>
                                                                                <ReactSVG key={item.id + index} src={floorplanChild} />
                                                                            </Child>
                                                                        )
                                                                    })}
                                                                </Children>
                                                            </>
                                                        }
                                                        {(item.sleepsAdditional > 0) &&
                                                            <>

                                                                <Plus>
                                                                    <ReactSVG src={plusSvg} />
                                                                </Plus>
                                                                <Children>
                                                                    {Array.apply(null, { length: item.sleepsAdditional }).map((i, index) => {
                                                                        return (
                                                                            <Child opacity={1} key={item.id + index}>
                                                                                <ReactSVG key={item.id + index} src={floorplanChild} />
                                                                            </Child>
                                                                        )
                                                                    })}
                                                                </Children>
                                                            </>
                                                        }
                                                    </FloorplanConfigurationIcons>
                                                    <FloorplanConfigurationText>
                                                        {item.size &&
                                                            item.size
                                                        }
                                                        {item.shape &&
                                                            <p>{item.shape}</p>
                                                        }
                                                    </FloorplanConfigurationText>
                                                    {/* <FloorplanConfigurationAdditionalPrice>
                                                        {
                                                            item.additionalPrice ? '+$' + item.additionalPrice : '$' + 0
                                                        }
                                                    </FloorplanConfigurationAdditionalPrice> */}
                                                </FloorplanConfiguration>
                                            )
                                        })}
                                    </Floorplans>

                                        <ButtonContainer fixed={fixed ? 1 : 0} disablePrice={props.disablePrice ? 1 : 0}>
                                            <Link href={modelUrl && `${modelUrl}/decor`}>
                                                <a onClick={handleSaveData}>
                                                    <Cta>Next</Cta>
                                                </a>
                                            </Link>
                                        </ButtonContainer>
         
                                </TabsContainerConfig>
                            </FloorplanContent>

                        }
                    </SecondSection>
                </SectionsContainer>
            </FloorplanContainer>
          
        </Container>

        
        }
        
        {((res && Object.values(res).length == 0) || (seriesName != res.seriesName) || (res?.selectedModelFloorplan?.activeFloorPlanModel?.uri != modelName) || (res?.selectedModelFloorplan?.activeFloorPlanModel?.uri != modelName) || (res && !res.selectedModelFloorplan)) &&
            <Container background={background} colourTheme={colourTheme} errorPage={((res && Object.values(res).length == 0) || (seriesName != res.seriesName) || (res && !res.selectedModelFloorplan)) ? 1 : 0}>
                <Link  href={seriesUrl && seriesUrl.link && seriesUrl.link.href ? `${seriesUrl.link.href}` : '#'}>
                    <a>
                        <Cta>Select Model First</Cta>
                    </a>
                </Link>
            </Container>
        }
        
        {( (res) && (res.seriesName == seriesName) && (res?.selectedModelFloorplan?.activeFloorPlanModel?.uri == modelName) && (res.selectedModel) && (Object.values(res.selectedModel).length > 0)) &&
            <>
                {(!props.disablePrice) &&
                    <ModelPriceContainer containerWidth={currentWidth > 0 ? currentWidth : 0} fixed={fixed ? 1 : 0}>
                        <ModelPrice
                            price={currentPrice}
                            additionalPrice={additionalPrice}
                            rates={modelPrice.rates}
                        />
                    </ModelPriceContainer>      
                }
            
                <InviewContainer ref={inViewRef}>

                </InviewContainer>

                <ModelFooterContainer>
                    <ModelFooter
                        dealers={dealers}
                        countryProps={countryProps}
                        getCurrentSetSetLocation={getCurrentSetLocation}
                        openPostcodePopup={openPostcodePopup}
                        setOpenPostcodePopup={setOpenPostcodePopup}
                        staticData={true}
                    />
                </ModelFooterContainer>
            </>
        }
     </>
    )
}

ModelFloorplanConfiguration.propTypes = {
    seriesName: propTypes.string,
    seriesUrl: propTypes.object,
    seriesParams: propTypes.string,
    modelName: propTypes.string,
    modelUrl: propTypes.string,
    modelParams: propTypes.string,
    modelPrice: propTypes.object,
    currentWidth: propTypes.number,
    dealers: propTypes.array,
    countryProps: propTypes.object
}

ModelFloorplanConfiguration.defaultProps = {
    colourTheme: 'light',
    type: 'caravan',
    seriesName: null,
    seriesUrl: {},
    seriesParams: null,
    modelName: null,
    modelUrl: null,
    modelParams: null,
    modelPrice: {},
    currentWidth: null,
    dealers: [],
    countryProps: {}
}

export default ModelFloorplanConfiguration